import { DatePicker } from 'antd';
import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import styled from 'styled-components';
import { useAttendance } from '../hooks/useAttendance';

interface Props {}

const StaffAttendanceView: React.FC<Props> = () => {
  //   const [selectedDate, setSelectedDate] = React.useState<string>('');
  const attendance = useSelector((state: RootState) => state.staff_attendance);
  const { fetchStaffAttendance } = useAttendance();

  React.useEffect(() => {
    fetchStaffAttendance();
    // eslint-disable-next-line
  }, []);

  return (
    <AttendanceViewWrapper>
      <KPageHeader
        title="Staff Attendance"
        rightButtonTitle="Create New"
        onRightButtonClick={() => {}}
      />
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing attendance of staffs"
      />
      <section className="page-tabs">
        <DatePicker />
      </section>

      {/* <section className="page-table">
        {attendance.status === 'loading' && <KSpinner />}
        {attendance.status === 'data' && (
          <DataTable
            customStyles={tableCustomStyles}
            className="data-table"
            noHeader
            highlightOnHover
            responsive={true}
            data={attendance.data}
            columns={tableColumn()}
          />
        )}
      </section> */}
    </AttendanceViewWrapper>
  );
};

export const AttendanceViewWrapper = styled.div`
  padding-right: 20px;
  .page-tabs {
    margin: 16px 0;
    display: flex;
    justify-content: flex-end;
    .grade-select-field {
      min-width: 250px;
    }
  }
`;

export default StaffAttendanceView;
